// src/shared/components/fields/SelectField.tsx
import React, { forwardRef, useId } from "react";
import type { SelectHTMLAttributes } from "react";
import styles from "./Fields.module.scss";

interface Option {
  value: string | number;
  label: string;
}

interface SelectFieldProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  options: Option[];
  error?: string;
}

export const SelectField = forwardRef<HTMLSelectElement, SelectFieldProps>(
  ({ label, options, error, className = "", id, ...props }, ref) => {
    const generatedId = useId();
    const fieldId = id || generatedId;

    return (
      <div className={`${styles.fieldContainer} ${className}`}>
        {label && (
          <label htmlFor={fieldId} className={styles.label}>
            {label}
          </label>
        )}

        <div className={styles.selectWrapper}>
          <select
            ref={ref}
            id={fieldId}
            className={`${styles.select} ${error ? styles.hasError : ""}`}
            {...props}
          >
            {options.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
          {/* Кастомная стрелка */}
          <span className={styles.selectArrow} />
        </div>

        {error && <span className={styles.errorMessage}>{error}</span>}
      </div>
    );
  }
);

SelectField.displayName = "SelectField";
